'use client';

import React from 'react';

export const ScrollTargetContext =
	React.createContext<React.RefObject<HTMLDivElement | null> | null>(null);

export const useScrollTargetRef = () => {
	const context = React.useContext(ScrollTargetContext);
	if (!context) {
		throw new Error(
			'useScrollTargetRef must be used within a ScrollTargetContext provider',
		);
	}
	return context;
};

export const FilterScrollTarget = ({
	children,
	className,
}: {
	children: React.ReactNode;
	className?: string;
}) => {
	const scrollTargetRef = React.useRef<HTMLDivElement>(null);
	return (
		<ScrollTargetContext.Provider value={scrollTargetRef}>
			<div ref={scrollTargetRef} className={className}>
				{children}
			</div>
		</ScrollTargetContext.Provider>
	);
};
